<template>
  <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
    <b-row class="m-0">
      <b-col v-if="yearDrop" cols="2">
        <select @change="durationChange" v-model="selectedYear">
          <option value="0">Select Base Year</option>
          <option :key="d" v-for="d in yearOptionData" :value="d">{{ d }}</option>
        </select> 
       
      </b-col>
      <b-col>
        <b-form-group label="" v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group
            id="checkbox-group-1"
            v-model="selectedChart"
            :options="chartOptions"
            :aria-describedby="ariaDescribedby"
            name="flavour-1"
            @input="selectionChart"
          ></b-form-checkbox-group>
        </b-form-group>
      </b-col>
      <b-col class="text-right">
        <downloadChart :commitName="'Sector Valuations'" />
      </b-col>
    </b-row>
    <b-row class="m-0 chartTabPanel autoCursor">
      <b-col
        :class="activeMultiple"
        v-if="selectedChart.includes('us') && chartData1 && chartData1.length"
        ref="capture"
      >
        <div class="subTabClass">
          <PlotlyMultiLineChart
            class="svgChart"
            v-bind:data-set="chartData1"
            :xAxisType="xAxisType"
            :yAxisType="yAxisType"
            :margin="margin"
            :title="chartTitle"
            :name="name"
            :chartWidth="chartWidth"
            :chartHeight="chartHeight"
            :tickFormat="tickFormat"
            :tickFormatYaxis2="tickFormatYaxis2"
            :rangeslider="rangeslider"
            :min="min"
            :max="max"
          >
          </PlotlyMultiLineChart>
        </div>
      </b-col>
      <b-col
        :class="activeMultiple"
        v-if="selectedChart.includes('eu') && chartData2 && chartData2.length"
        ref="capture"
      >
        <div class="subTabClass">
          <PlotlyMultiLineChart
            class="svgChart"
            v-bind:data-set="chartData2"
            :xAxisType="xAxisType"
            :yAxisType="yAxisType"
            :margin="margin"
            :title="chartTitle"
            :name="name"
            :chartWidth="chartWidth"
            :chartHeight="chartHeight"
            :tickFormat="tickFormat"
            :tickFormatYaxis2="tickFormatYaxis2"
            :rangeslider="rangeslider"
            :min="min"
            :max="max"
          >
          </PlotlyMultiLineChart>
        </div>
      </b-col>
    </b-row>
  </fullscreen>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
//import bFormSlider from 'vue-bootstrap-slider/es/form-slider';
import "bootstrap-slider/dist/css/bootstrap-slider.css";
//------------Import Charts----------
import PlotlyMultiLineChart from "@/components/charts/PlotlyCharts/MultiLineWithoutOption.vue";
import moment from "moment";
export default {
  name: "sector_valuations",
  components: {
    PlotlyMultiLineChart,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      valuation: "valuation",
      sectorValuations: "sectorValuations",
      isFullScreen: "isFullScreen",
      currentVersionaHolder: "currentVersionaHolder",
      historyCalDropDown: "historyCalDropDown",
    }),
    valuationChildren() {
      return this.valuation.child;
    },
  },
  data() {
    return {
      chartTitle: "",
      name: "Sector_valuation",
      yAxisType: "linear",
      xAxisType: "date",
      selectedYear: '0',
      chartWidth: 1250,
      chartHeight: 330,
      tickFormat: "",
      tickFormatYaxis2: "0.0%",
      chartData: [],
      yearOptionData: [],
      selectedChart: ["us"],
      chartData1: null,
      chartData2: null,
      rangeslider: true,
      activeMultiple: "col-12",
      min: 1971,
      max: 2020,
      chartOptions: [
        { text: "US", value: "us" },
        { text: "EU", value: "eu" },
      ],
      sliderHide: true,
      yearDrop: true,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      margin: {
        l: 80,
        r: 80,
        b: 120,
        t: 40,
        pad: 2,
      },
      drop_down_values: [],
    };
  },
  created() {
    this.getChartData();
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setDownloadInfo",
      "getChartDataById",
      "getChartHistoricalData",
      "getIframeChartDataById",
      "setSectorValuations",
      "currentVersionUpdateHandler",
    ]),
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },
    durationChange(){
      let self = this
      setTimeout(function(){
        self.getChartData()
      },200)

    },
    windowResize(e) {
      // this.layout.width = this.$refs.capture.clientWidth-50;
    },
    // handleFocusFromChild(value){
    //   // return this.getChartHistoricalData;
    //   // console.log("dddddddddddd", value);
    //   this.getChartHistoricalData({
    //       table_pk: value,
    //       chart_id: 179,
    //       chartName: "Sector Valuations",
    //   });
    // },
    //  async handelSaveSelectedVersion(value){
    //     // console.log("handelSaveSelectedVersion", value);
    //     // return this.getChartHistoricalData;
    //     // this.getChartHistoricalData({
    //       //     table_pk: value,
    //       //     chart_id: 179,
    //       //     chartName: "Sector Valuations",
    //       // });
    //       // let responce = await this.getChartDataById({
    //       //   id: 179,
    //       //   chartName: "Sector Valuations",
    //       //   navigate: false,
    //       // });
    //       // console.log("save++ Selected Version+++++", value, responce);
    //   },
    getClass(key) {
      if (this.selectedChart.includes(key)) {
        return "col-md-6";
      }
    },
    selectionChart() {
      if (this.selectedChart.length > 1) {
        this.activeMultiple = "col-md-6";
      } else {
        this.activeMultiple = "col-12";
      }
    },
    async getChartData() {
      //------------Formatted Data------------
      this.setDownloadInfo({
        fileName: this.title,
        downloadData: this.$refs.capture,
      });
      if (window.location.href.includes("auth_token=")) {
        let data = await this.getChartDataById({
          id: 179,
          chartName: "Sector Valuations",
          navigate: false,
        });
        // console.log("data--hrefffff", data);
        this.setSectorValuations(data.message);
        this.loadChartData(data.message);

        let payLoadObj = {
          table_pk: data.drop_down_values.current_version.table_pk,
          chart_id: data.drop_down_values.current_version.chart_id,
          chartName: "Sector Valuations",
        };
        let version = {
          version_data: payLoadObj,
          versionToggleValue: false,
        };
        // console.log("versionnnnnnn", version);
        this.currentVersionUpdateHandler(version);
      } else {
        let data = null;
        if (
          (typeof this.sectorValuations == "undefined" ||
            this.sectorValuations.length === 0) &&
          data != null
        ) {
          let filterChart = this.valuationChildren.filter(
            (item) => "Sector Valuations" === item.objectname
          );
          let data = await this.getChartDataById({
            id: filterChart[0].chartId,
            chartName: filterChart[0].objectname,
            navigate: false,
          });
          this.loadChartData(data);
          return false;
        } else {
          this.loadChartData(this.sectorValuations);
        }
      }
    },
    loadChartData(chartData) {
      let data = JSON.parse(JSON.stringify(chartData));
      let formattedDataUs = data.us;
      let formattedDataEU = data.eu;
      
      let selectedYearInInt = parseInt(this.selectedYear)
      
      if (formattedDataUs) {
        for (let i = 0; i < formattedDataUs.length; i++) {
          let USlineColor = formattedDataUs[i].line.color;
          let EUlineColor = formattedDataEU[i].line.color;
          formattedDataUs[i].line = {
            shape: "spline",
            smoothing: 1.3,
            color: USlineColor,
          };
          formattedDataEU[i].line = {
            shape: "spline",
            smoothing: 1.3,
            color: EUlineColor,
          };
          let us = { x: [], y: [] };
          let eu = { x: [], y: [] };
          if (this.selectedYear) {
            for (let j = 0; j < formattedDataUs[i].x.length; j++) {
              
              if (
                parseInt(moment(formattedDataUs[i].x[j]).format("YYYY")) >= selectedYearInInt
              ) {
                us.x.push(formattedDataUs[i].x[j]);
                us.y.push(formattedDataUs[i].y[j]);
              }
            }
            for (let k = 0; k < formattedDataEU[i].x.length; k++) {
              if (
                parseInt(moment(formattedDataEU[i].x[k]).format("YYYY")) >= selectedYearInInt
              ) {
                eu.x.push(formattedDataEU[i].x[k]);
                eu.y.push(formattedDataEU[i].y[k]);
              }
            }

            formattedDataUs[i].x = us.x;
            formattedDataEU[i].x = eu.x;
            formattedDataUs[i].y = us.y;
            formattedDataEU[i].y = eu.y;
          }
        }
      }

      let yearDataUs = data.us[0].x.map(function(date) {
        return moment(date).format("YYYY");
      });
      let yearDataEU = data.eu[0].x.map(function(date) {
        return moment(date).format("YYYY");
      });
      formattedDataEU[0].year = [...new Set(yearDataEU)];
      formattedDataUs[0].year = [...new Set(yearDataUs)];

      let yearListDropdown = chartData.us[0].x.map(function(date) {
        return moment(date).format("YYYY");
      });
     
      this.yearOptionData = [...new Set(yearListDropdown)];

      formattedDataUs[1].yaxis = "y2";
      formattedDataEU[1].yaxis = "y2";

      // console.log("formattedDataUs", formattedDataUs);
      //------------Line Charts------------
      this.chartData1 = [];
      this.chartData2 = [];
      setTimeout(() => {
        this.chartData1 = [
          Object.assign({}, formattedDataUs[0], { attribute: "someValue" }),
          Object.assign({}, formattedDataUs[1], { attribute: "someValue" }),
        ];
        this.chartData2 = [
          Object.assign({}, formattedDataEU[0], { attribute: "someValue" }),
          Object.assign({}, formattedDataEU[1], { attribute: "someValue" }),
        ];
      }, 10);
      // console.log("chartData1", this.chartData1);
      // }
    },
  },
  watch: {
    sectorValuations: {
      deep: true,
      handler() {
        let data = JSON.parse(JSON.stringify(this.sectorValuations));
        this.loadChartData(data);
        // console.log("sectorValuations++++watcherrrrrr", this.sectorValuations);
      },
    },
  },
};
</script>
